import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleServices = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center">
              <i className="ri-smartphone-line text-white text-2xl"></i>
            </div>
            <span className="text-2xl font-bold text-gray-900" style={{ fontFamily: "Pacifico, serif" }}>
              Device Doctor
            </span>
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Home</Link>
            <Link to="/about" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">About</Link>
            
            <div className="relative">
              <button 
                onClick={toggleServices}
                className="text-gray-700 hover:text-red-600 transition-colors flex items-center cursor-pointer"
              >
                Services
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              
              {isServicesOpen && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50">
                  <Link to="/services" className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
                    All Services
                  </Link>
                  <div className="border-t border-gray-100 my-2"></div>
                  <Link to="/samsung-service" className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
                    Samsung Repair
                  </Link>
                  <Link to="/apple-service" className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
                    Apple Repair
                  </Link>
                  <Link to="/google-pixel-service" className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
                    Google Pixel Repair
                  </Link>
                  <Link to="/oneplus-service" className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
                    OnePlus Repair
                  </Link>
                  <Link to="/vivo-service" className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
                    Vivo Repair
                  </Link>
                  <Link to="/realme-service" className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
                    Realme Repair
                  </Link>
                  <Link to="/motorola-service" className="block px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
                    Motorola Repair
                  </Link>
                </div>
              )}
            </div>
            
            <Link to="/contact" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Contact</Link>
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <div className="text-right">
              <p className="text-sm text-gray-600">Call Us Now</p>
              <a href="tel:+918714014140" className="text-red-600 font-semibold cursor-pointer">+91 8714014140</a>
            </div>
            <a 
              href="https://wa.me/918714014140" 
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors flex items-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
          </div>

          <button 
            onClick={toggleMenu}
            className="lg:hidden text-gray-700 hover:text-red-600 transition-colors cursor-pointer"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4">
            <nav className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Home</Link>
              <Link to="/about" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">About</Link>
              <Link to="/services" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Services</Link>
              <Link to="/contact" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Contact</Link>
              
              <div className="pt-4 border-t border-gray-200">
                <a href="tel:+918714014140" className="text-red-600 font-semibold block mb-2 cursor-pointer">
                  <i className="ri-phone-line mr-2"></i>
                  +91 8714014140
                </a>
                <a 
                  href="https://wa.me/918714014140" 
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors inline-flex items-center whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp Us
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};